import { Chip, Tooltip } from "@mui/material";
import GameToolTip from "../Tooltips/GameToolTip";
import MatchToolTip from "../Tooltips/MatchToolTip";
import {
  RankColors,
  RankText,
  TeamsList,
  TeamLogos,
} from "../../globals/Globals";
import {
  Match,
  Game,
  Rank,
  Position,
  Placing,
  Diff,
  PlayerOwnership,
  PlacingWithCaptainVice,
  DiffWithCaptainsVice,
  Dismissal,
  Player,
  Over,
} from "../../types/types";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ConstructionOutlined } from "@mui/icons-material";
import {
  RenderTeamCellToolTip,
  RenderDismissalImage,
  RenderOverImage,
} from "../../globals/TableFunctions";
import _ from "underscore";
import { CURRENT_SEASON } from "../../globals/BBLData";

export const OversColumns: GridColDef[] = [
  { field: "season", headerName: "Season", width: 100 },
  { field: "round", headerName: "Round" },
  {
    field: "opposition",
    headerName: "Opponent",
    width: 190,
    renderCell: (params: GridRenderCellParams<Date>) =>
      RenderTeamCellToolTip(
        params.row.opposition,
        params.row.oppositionlogo,
        params.row.oppositioncolors,
        params.row.game
      ),
  },
  { field: "overNumber", headerName: "Over #" },
  {
    field: "bowler",
    headerName: "Bowler",
    width: 190,
    renderCell: (params: GridRenderCellParams<Date>) =>
      RenderOverImage(params.row.bowler),
  },
  { field: "bowlingStyles", headerName: "Bowling Style", width: 175 },
  {
    field: "batter",
    headerName: "Batter",
    width: 190,
    renderCell: (params: GridRenderCellParams<Date>) =>
      RenderOverImage(params.row.batter),
  },
  { field: "battingStyles", headerName: "Batting Style", width: 175 },
  { field: "balls", headerName: "Balls" },
  { field: "runs", headerName: "Runs" },
  { field: "batterOut", headerName: "Out?" },
];

export function BuildOversTable(overs: Over[], thePlayerID) {
  let datagridrows = [];
  overs.forEach(function (over, index) {
    if (over.season === CURRENT_SEASON) {
      let oppositionname = "";
      //@ts-ignore
      let thegame = over.thegame;
      if (thegame) {
        if (thePlayerID === thegame.player[0]) {
          oppositionname = thegame.opposition?.name
            ? thegame.opposition.name
            : "";
        } else {
          oppositionname = thegame.team?.name ? thegame.team.name : "";
        }
      } else {
        thegame = { season: "", round: "" };
      }

      //let oppositionname = dismissal.opposition?.name ? dismissal?.opposition?.name : '';
      let oppositioncolors: string[] = TeamsList[oppositionname];
      let oppositionlogo = TeamLogos[oppositionname];
      datagridrows.push({
        id: `over-${index}`,
        opposition: oppositionname,
        oppositioncolors: oppositioncolors,
        oppositionlogo: oppositionlogo,
        season: thegame.season,
        game: over.thegame,
        round: thegame.round,
        overNumber: over.overNumber,
        balls: over.balls,
        runs: over.runs,
        bowlingStyles: over.bowlingStyles,
        battingStyles: over.battingStyles,
        batter: over.batter,
        bowler: over.bowler,
      });
    }
  });
  console.log("OverDatagrid: ", datagridrows);
  return datagridrows;
}
